import { Navigate, useLocation, useParams } from 'react-router-dom';
import {
  PATIENT_DETAILS_PATH,
  PATIENT_HOME_PATH,
} from '@/lib/patientPortalApi';

/**
 * `/your-health/...` was the patient base path before `/profile`; emails
 * already sent still carry it. The edit page moved from `profile` to
 * `details`; every other sub-path kept its name.
 */
export function LegacyPatientPathRedirect() {
  const rest = (useParams()['*'] ?? '').replace(/\/+$/, '');
  const { search } = useLocation();
  const to =
    rest === 'profile'
      ? PATIENT_DETAILS_PATH
      : `${PATIENT_HOME_PATH}${rest ? `/${rest}` : ''}`;
  return <Navigate to={`${to}${search}`} replace />;
}
